import type { Logger } from '@devhacker/shared/libs/logger';
import type { IWidgetsApi } from '~/types/api/widgets';
import { API_URL, API_URL_PREFIX, API_TIMEOUT } from '~/constants/config';
import { createAxiosLikeFetch } from '@devhacker/shared/libs/fetch/createAxiosLikeFetch';
import { createLoggerInterceptors } from '@devhacker/shared/libs/logger';

type Params = {
  $logger: Logger;
};

export default ({ $logger }: Params): IWidgetsApi => {
  const widgetsFetch = createAxiosLikeFetch({
    baseURL: `${API_URL}${API_URL_PREFIX}`,
    timeout: API_TIMEOUT,
    ...createLoggerInterceptors($logger, 'widgets'),
  });

  return {
    // sidebars
    // curl --location --request OPTIONS 'https://stage.burninghut.ru/wp-json/bh-kiss/v1/sidebars'
    sidebars() {
      return widgetsFetch('sidebars');
    },
  };
};
